<template>
    <div class="user-search-tabs">
        <div class="user-search-tabs__header">
            <div
                v-for="(tab, index) in tabs"
                :key="tab.id"
                class="user-search-tabs__header-tab"
                :class="{
                    'user-search-tabs__header-tab--active': tab.isActive,
                }"
                @click="selectTab(index)"
            >
                <span
                    class="user-search-tabs__header-tab-title"
                    :class="{active: tab.isActive}"
                >
                  {{ tab.title }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "UserSearchTabs",
    props: {
        tabs: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            currentTab: 0,
        };
    },
    methods: {
        selectTab(index) {
            this.tabs.forEach((tab) => {
              tab.isActive = false;
            });
            console.log(this.tabs, this.currentTab, 'tabsss');
            this.tabs[this.currentTab].isActive = false;
            this.tabs[index].isActive = true;
            this.currentTab = index;
            this.$emit("change-tab", this.tabs[index]);
        },
    },
};
</script>
<style scoped lang="scss">
@import "~@/styles/rem";
@import "~@/styles/variables";

.user-search-tabs {
    width: 100%;
    background-color: #F8F8F8;
    padding: 0 mrem(20);
    margin: 0 mrem(-20);
    overflow: hidden;

    @include on-desktop {
        padding: 0 rem(20);
        margin: 0 rem(-20);
    }

    &__header {
        display: flex;
        padding-top: mrem(20);

        @include on-desktop {
            padding-top: rem(20);
        }

        &-tab {
            cursor: pointer;
            background-color: #F8F8F8;
            text-align: center;
            color: $color-main-grey;
            font-style: normal;
            font-weight: 400;
            padding: mrem(10) mrem(20);
            border-radius: mrem(16) mrem(16) 0 0;
            margin-right: mrem(6);
            font-size: mrem(16);
            line-height: mrem(20);
            box-shadow: 0 mrem(-2) mrem(10) 0 rgba(70, 99, 171, 0.10);

            @include on-desktop {
                padding: rem(10) rem(20);
                border-radius: rem(16) rem(16) 0px 0px;
                margin-right: rem(6);
                font-size: rem(16);
                line-height: rem(20);
                box-shadow: 0 rem(-2) rem(10) 0 rgba(70, 99, 171, 0.10);
            }

            &--active {
                background-color: #FFF;
            }

            .active {
                display: flex;
                align-items: center;
                color: $color-main-blue;
                font-weight: 700;

                &::before {
                    content: "";
                    display: block;
                    background-color: $color-main-blue;
                    width: mrem(6);
                    margin-right: mrem(8);
                    height: mrem(6);
                    border-radius: mrem(3);

                    @include on-desktop {
                        width: rem(6);
                        margin-right: rem(8);
                        height: rem(6);
                        border-radius: rem(3);
                    }
                }
            }
        }
    }
}
</style>
